import React, { Component } from "react";
import { message, PageHeader, Spin, Row, Col, Select, Popconfirm, Alert, Space, Switch } from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  ButtonItem,
  InputItem,
  NotificacionPolizas,
  round2Decimals,
  ErrorItem,
  SwitchItem,
  MensajeError,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import {
  DollarOutlined,
  FileTextOutlined
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import MandarCorreoComplemento from "../MandarCorreoComplemento/MandarCorreoComplemento";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import complementoPdf from "../../../../Pdf/complementoPdf";
import cobroPdf from "../../../../Pdf/cobroPdf";
import MandarCorreoPago from "../MandarCorreoPago/MandarCorreoPago";
import cobroFernandoPdf from "../../../../Pdf/cobroFernandoPdf";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";
import EncabezadoClienteCobro from "./EncabezadoClienteCobro";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select
moment.locale("es");

class VerVentasCliente extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    ventasCliente: undefined,
    todasBancos: null,
    objetoBancos: null,
    todasFormasDePago: null,
    objetoFormasDePago: null,
    todasMonedas: null,
    objetoMonedas: null,
    numeroFacturas: 0,
    modalCorreo: false,
    modalCorreoId: null,
    monedaDePago: 'MXN',
    modalCorreoPago: false,
    id: this.props.location.state.id,
    notasDeCreditoPendiente: [],
    objetoNotasPendientes: null,
    anticiposPendientes: [],
    objetoAnticiposPendientes: null,
    abonosPendientesClientes: [],
    objetoAbonosPendientes: null,
    factorajeFinancieroCXC: false,
    clienteFactoraje: false,
    pagarConFactoraje: false,
    todasCuentasCliente: [],
    objetoCuentasCliente: null,
    todasBancosSat : [],
    pagarConNotas: false,
    // Cobro junto con otros clientes del mismo RFC y razón social
    ventasPrincipal: [],
    clientesMismoRfc: [],
    nombresClientes: {},
    incluirMismoRfc: false,
    cargandoMismoRfc: false,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "formasdepago/selectFormasDePago",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasFormasDePago: res.data });
          this.setState({
            objetoFormasDePago: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_FormaPago + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: res.data });
          this.setState({
            objetoBancos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + ' - ' + value.banco}
                </Option>
              );
            }),
          });
        }
      });
      await axios
        .post(
          "bancosSat/selectBancosSat",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({ todasBancosSat: res.data });
          }
        });
    await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: this.state.todasBancos && this.state.todasBancos?.length > 0 ? [...this.state.todasBancos, ...res.data] : res.data });
          this.setState({
            objetoBancos: this.state.objetoBancos && this.state.objetoBancos?.length > 0 ? [...this.state.objetoBancos, ...res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            })] : res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cuentasporcobrar/selectVentasPCliente",
        {
          empresaId: this.props.empresaId,
          clienteId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del cliente");
        } else {
          let numeroFacturas = 0
          let nuevasVentas = this.prepararVentas(res.data.ventas);

          const primerVenta = res.data.ventas[0];
          const cuentas = primerVenta?.cliente?.cuentasBancoCliente || [];
          const detallesBancos = primerVenta?.detallesBancosCliente || [];

          this.setState({
            ventasCliente: nuevasVentas, numeroFacturas,
            ventasPrincipal: nuevasVentas,
            anticiposPendientes: res.data.anticiposPendientes,
            objetoAnticiposPendientes: res.data.anticiposPendientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaFactura).format('L') + " - " + dineroDisabledMask(value.totalPagar - (value.totalPagadoAnticipos || 0)) + ' - ' + value.moneda.abreviacion}
                </Option>
              );
            }),
            notasDeCreditoPendiente: res.data.notasDeCreditoPendiente,
            objetoNotasPendiente: res.data.notasDeCreditoPendiente.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {
                  (value.remisionSerie ? (value.remisionSerie + " - " + value.remisionNumero + " | ") : "") +
                  (value.facturaSerie ? (value.facturaSerie + " - " + value.facturaNumero + " | ") : "") +
                  moment(value.fechaFactura || value.fechaRemision).format('L') + " - " + dineroDisabledMask(value.totalPagar - value.totalPagado) + ' - ' + value.moneda.abreviacion +
                  (value.concepto ? " | " + value.concepto : "")}
                </Option>
              );
            }),
            abonosPendientesClientes: res.data.abonosPendientesClientes,
            objetoAbonosPendientes: res.data.abonosPendientesClientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaPago).format('L') + " - " + dineroDisabledMask(value.monto - (value.totalPagadoAbono || 0)) + ' - ' + value.moneda?.abreviacion}
                </Option>
              );
            }),
            factorajeFinancieroCXC: res.data.factorajeFinancieroCXC,
            todasCuentasCliente: cuentas,
            objetoCuentasCliente: cuentas.map((cta, index) => {
              const bancoInfo = detallesBancos.find(
                (b) => b._id.toString() === cta.bancoSatId?.toString()
              );
              const labelText = `${cta.cuenta}${cta.descripcion ? ` - ${cta.descripcion}` : ""} (${bancoInfo?.nombreCorto || 'Sin Banco'})`;
              return (
                <Option 
                  value={cta.cuenta} 
                  key={index} 
                  rfc={bancoInfo?.rfc} 
                  nombrebanco={bancoInfo?.nombreCorto}
                >
                  {labelText} 
                </Option>
              );
            })
          });
          // Por esta versión corregida:
          let bancoIdDefault = null;
          // Busca el primer cliente que tenga bancoId
          for (let venta of res.data.ventas) {
            if (venta.cliente && venta.cliente.bancoId) {
              bancoIdDefault = venta.cliente.bancoId;
              break;
            }
          }

          const formaDePagoIdDefault = this.props.location.state?.formaDePagoId || "6125149afe07662acc100d58";

          const extraBanco = {};
          if (bancoIdDefault) {
            const banco = this.state.todasBancos?.find(b => b._id?.toString() === bancoIdDefault?.toString());
            if (banco) {
              extraBanco.ctaBeneficiario = banco.ctaBeneficiario;
              extraBanco.rfcEmisorCtaBen = banco.rfcEmisorCtaBen;
            }
          }
          this.formRef.current.setFieldsValue({
            ventas: nuevasVentas,
            ...(bancoIdDefault && { bancoId: bancoIdDefault }),
            formaDePagoId: formaDePagoIdDefault,
            ...extraBanco,
          });
        }
      });
    await this.consultarClientesMismoRfc();
    this.setState({ loading: false });
  }

  // Número a mostrar, saldo y orden por folio de las ventas que devuelve selectVentasPCliente.
  prepararVentas(ventas) {
    const nuevasVentas = (ventas || []).map((value) => {
      let numero = ''
      if (value.remision) {
        numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
      }
      if (value.factura) {
        if (numero !== '') {
          numero += ' '
        }
        numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
      }
      return {
        ...value,
        numero,
        proyectoNombre: value.proyectoNombre,
        tipoDeCambioVenta: value.tipoDeCambio,
        saldoPendiente: round2Decimals(value.totalPagar - value.totalPagado)
      };
    });
    nuevasVentas.sort((a, b) => {
      const facturaA = a.facturaNumero ?? Infinity;
      const facturaB = b.facturaNumero ?? Infinity;
      if (facturaA !== facturaB) return facturaA - facturaB;
      const remisionA = a.remisionNumero ?? Infinity;
      const remisionB = b.remisionNumero ?? Infinity;
      return remisionA - remisionB;
    });
    return nuevasVentas;
  }

  // Otros clientes con el mismo RFC y razón social que tienen ventas pendientes. Sus ventas
  // se pueden cobrar junto con las de este cliente: el backend valida que sean el mismo
  // contribuyente y abona a la cuenta contable de cada uno.
  async consultarClientesMismoRfc() {
    await axios
      .post(
        "cuentasporcobrar/selectClientesMismoRfc",
        { empresaId: this.props.empresaId, clienteId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const nombresClientes = {};
          if (res.data.principal) nombresClientes[res.data.principal._id] = res.data.principal.nombre;
          (res.data.clientes || []).forEach((c) => { nombresClientes[c._id] = c.nombre; });
          this.setState({ clientesMismoRfc: res.data.clientes || [], nombresClientes });
        }
      })
      .catch((e) => console.log(e));
  }

  // Las ventas del cliente abierto van siempre primero, así que al agregar o quitar las de
  // los otros clientes se conservan las cantidades que ya se capturaron en las suyas.
  // Cada fila lee `ventasCliente[arrayKey]`: el state nunca puede quedar más corto que el
  // formulario. Por eso al quitar se encoge primero el formulario y al agregar, el state.
  async alternarIncluirMismoRfc(incluir) {
    const ventasPrincipal = this.state.ventasPrincipal || [];
    const actuales = (this.formRef.current.getFieldValue("ventas") || []).slice(0, ventasPrincipal.length);
    if (!incluir) {
      this.formRef.current.setFieldsValue({ ventas: actuales });
      this.setState({ incluirMismoRfc: false, ventasCliente: ventasPrincipal });
      return;
    }
    this.setState({ cargandoMismoRfc: true });
    try {
      const respuestas = await Promise.all(
        this.state.clientesMismoRfc.map((cliente) =>
          axios.post(
            "cuentasporcobrar/selectVentasPCliente",
            { empresaId: this.props.empresaId, clienteId: cliente._id },
            { headers: this.props.headersToken }
          )
        )
      );
      const ventasOtros = respuestas.flatMap((res) =>
        res.data.status === 404 ? [] : this.prepararVentas(res.data.ventas)
      );
      this.setState({
        incluirMismoRfc: true,
        ventasCliente: [...ventasPrincipal, ...ventasOtros],
        cargandoMismoRfc: false,
      });
      this.formRef.current.setFieldsValue({ ventas: [...actuales, ...ventasOtros] });
    } catch (e) {
      console.log(e);
      this.setState({ cargandoMismoRfc: false });
      message.error("No se pudieron consultar las ventas de los otros clientes");
    }
  }

  // Con ventas de otros clientes la tabla se agrupa por cliente (TabbedDynamicTable).
  agrupacionPorCliente = () => ({
    activa: this.state.incluirMismoRfc,
    obtenerGrupo: (arrayKey) => {
      const clienteId = String(this.state.ventasCliente?.[arrayKey]?.cliente?._id || this.state.id);
      return {
        id: clienteId,
        nombre: this.state.nombresClientes[clienteId] || "",
        principal: clienteId === String(this.state.id),
      };
    },
    renderEncabezado: (props) => (
      <EncabezadoClienteCobro {...props} ventasCliente={this.state.ventasCliente} />
    ),
  });

  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    let cantidadPagarTotal = 0;
    for (const [key, value] of values.ventas.entries()) {


      let cantidadPagar = value.cantidadPagar ? value.cantidadPagar : 0
      cantidadPagarTotal += cantidadPagar

      if (values.pagarConFactoraje) {
        const equivalencia = values.tipoDeCambioPago / value.tipoDeCambioVenta
        let totalPagar = this.state.ventasCliente[key].totalPagar || 0;
        let totalPagado =
          this.state.ventasCliente[key]?.totalPagado || 0;

        const saldoPendiente = round2Decimals(
          (totalPagar - totalPagado) / equivalencia
        );
        if (round2Decimals(cantidadPagar + value.montoFactoraje) > saldoPendiente) {
          return message.info('No se puede pagar mas del saldo pendiente de la venta con factoraje')
        }
      }
    }
    if (values.pagarConNotas) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === values.notaId.toString())
      // Contra el saldo (no contra el total de la nota) y redondeado, igual que el backend.
      if (round2Decimals(cantidadPagarTotal) > round2Decimals(notaCredito.totalPagar - (notaCredito.totalPagado || 0))) {
        return message.info('No se puede pagar mas del saldo pendiente de la nota de credito')
      }
    }
    if (values.pagarConAnticipo) {
      const anticipo = this.state.anticiposPendientes.find((valueTodasAnticipos) => valueTodasAnticipos._id.toString() === values.anticipoId.toString())
      if (round2Decimals(cantidadPagarTotal) > round2Decimals(anticipo.totalPagar - (anticipo.totalPagadoAnticipos || 0))) {
        return message.info('No se puede pagar mas del saldo pendiente del anticipo')
      }
    }
    if (values.pagarConAbono) {
      const abonoCliente = this.state.abonosPendientesClientes.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === values.abonoId.toString())
      // Redondeado igual que el backend: la resta (y la suma de cantidades) en flotante
      // puede rechazar un monto que sí cabe en el saldo del abono.
      if (round2Decimals(cantidadPagarTotal) > round2Decimals(abonoCliente.monto - (abonoCliente.totalPagadoAbono || 0))) {
        return message.info('No se puede pagar mas del saldo pendiente del abono')
      }
    }
    if (cantidadPagarTotal === 0) return message.info('Se necesitan cantidades para poder hacer esta operación')
    const monedaIdPago = values.monedaId
    const tipoDeCambioPago = values.tipoDeCambioPago || 1
    const ventasConTcDistinto = (values.ventas || []).filter((v, idx) => {
      const ventaState = this.state.ventasCliente?.[idx]
      if (!ventaState || !v.cantidadPagar || v.cantidadPagar <= 0) return false
      if (ventaState.monedaId !== monedaIdPago) return false
      return round2Decimals(v.tipoDeCambioVenta) !== round2Decimals(tipoDeCambioPago)
    })
    if (ventasConTcDistinto.length > 0) {
      return message.error('Cuando la moneda de la venta y del pago son iguales, el tipo de cambio debe ser el mismo en todas las ventas a cobrar')
    }
    this.setState({ loading: true });
    axios
      .post(
        "cuentasporcobrar/cobrarVentasCliente",
        {
          ...values,
          empresaId: this.props.empresaId,
          clienteId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha registrado un pago");
          if (res.data.complemento) {
            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaComplemento.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

              window.registrarMovimiento({
                titulo: 'Complemento de Pago Emitido',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2,
                onClick: () => {
                  var xmltext = res.data.respuestaComplemento.data.cfdi;

                  var filename = nombreArchivo + ".xml";
                  var pom = document.createElement("a");
                  var bb = new Blob([xmltext], { type: "text/plain" });

                  pom.setAttribute("href", window.URL.createObjectURL(bb));
                  pom.setAttribute("download", filename);

                  pom.dataset.downloadurl = [
                    "text/plain",
                    pom.download,
                    pom.href,
                  ].join(":");
                  pom.draggable = true;
                  pom.classList.add("dragout");

                  pom.click();

                  const pdf = complementoPdf(res.data);

                  pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                },
              });
            }

            NotificacionPolizas(res.data.polizasId)
            this.setState({ modalCorreo: true, modalCorreoId: res.data.pagoId })
          } else {

            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaComplemento.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )';

              window.registrarMovimiento({
                titulo: 'Pago Emitido',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2,
                onClick: () => {
                  const pdf = (this.props.empresaId.toString() === '677c1e57f38e06c3032974fb') ? cobroFernandoPdf(res.data) : cobroPdf(res.data);

                  pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                },
              });
            }

            NotificacionPolizas(res.data.polizasId)
            this.setState({ modalCorreoPago: true, modalCorreoId: res.data.pagoId })
          }
        } else if (res.data.success === 1) {
          // El backend de `cobrarVentasCliente` ya pasa los rechazos del PAC por la
          // matriz del SAT y los manda en `errorTimbrado`: el mensaje redactado, dónde
          // corregirlo y el detalle crudo aparte. Antes esto leía `message` pelón y
          // tiraba todo eso.
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo efectuar el pago",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          // El controlador manda el motivo en `message` para decenas de validaciones
          // propias (saldo insuficiente, banco de otra moneda, cuenta contable
          // faltante). El texto de respaldo es sólo para cuando no vino nada.
          message.error(res.data.message || "Hubo un error y no se efectuo el pago");
        }
        this.setState({ loading: false });
      });
  }
  cerrarMandarCorreoComplemento() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }

  onChangeMoneda(value, fecha, setGlobal) {
    if (value && value !== "60c7e4396465ad440c41c15a") {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
            fecha: fecha || undefined,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success(
                "Se ha obtenido el tipo de cambio" +
                (res.data.monedaString ? " " + res.data.monedaString : "") +
                (res.data.dia ? " del día " + res.data.dia : "")
              );
            }
            const setVals = { tipoDeCambioPago: res.data.tipoDeCambio };
            if (setGlobal) {
              setVals.tipoDeCambioGlobal = res.data.tipoDeCambio;
            }
            this.formRef.current.setFieldsValue(setVals);
          }
        });
    } else {
      this.formRef.current.setFieldsValue({ tipoDeCambioPago: 1 });
    }
  }

  atras() {
    this.props.history.goBack();
  }
  cerrarMandarCorreoPago() {
    this.setState({
      modalCorreoPago: false,
      modalCorreoId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }

  onChangeNotaDeCredito(notaId) {
    if (notaId) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())
      this.formRef.current.setFieldsValue({ monedaId: notaCredito.monedaId, tipoDeCambioPago: notaCredito.tipoDeCambio })
    }
  }

  onChangeAnticipo(anticipoId) {
    if (anticipoId) {
      const anticipo = this.state.anticiposPendientes.find((valueTodasAnticipos) => valueTodasAnticipos._id.toString() === anticipoId.toString())
      this.formRef.current.setFieldsValue({ monedaId: anticipo.monedaId, tipoDeCambioPago: anticipo.tipoDeCambio })
    }
  }

  onChangeAbono(abonoId) {
    if (abonoId) {
      const abono = this.state.abonosPendientesClientes.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
      this.formRef.current.setFieldsValue({ monedaId: abono.monedaId, tipoDeCambioPago: abono.tipoDeCambioPago, fechaPago: abono.fechaPago ? moment(abono.fechaPago) : null })
    }
  }

  onSelectCuentaGuardada = (cuentaValue, option) => {
    if (option) {
      this.formRef.current.setFieldsValue({
        ctaOrdenante: cuentaValue,
        rfcEmisorCtaOrd: option.rfc || "",
        nomBancoOrdExt: option.nombrebanco || ""
      });
      message.success("Datos del cliente cargados");
    }
  };

  aplicarTipoCambioVentas = () => {
    const tipoDeCambio = this.formRef.current.getFieldValue('tipoDeCambioGlobal')
    if (!tipoDeCambio || tipoDeCambio <= 0) {
      return message.info('Capture un tipo de cambio válido')
    }
    const ventas = this.formRef.current.getFieldValue('ventas') || []
    const nuevasVentas = ventas.map((v, idx) => {
      const ventaState = this.state.ventasCliente?.[idx]
      if (ventaState && ventaState.monedaId !== '60c7e4396465ad440c41c15a') {
        return { ...v, tipoDeCambioVenta: tipoDeCambio }
      }
      return v
    })
    this.formRef.current.setFieldsValue({ ventas: nuevasVentas })
    this.forceUpdate()
    message.success('Tipo de cambio aplicado a ventas en moneda extranjera')
  };

  getVentasColumns() {
    if (this.state.pagarConFactoraje) {
      return [
        { title: "Código", width: "9%" },
        { title: "Proyecto", width: "13%" },
        { title: "Fecha Vencimiento", width: "9%" },
        { title: "Moneda", width: "8%" },
        { title: "T. C.", width: "9%" },
        { title: "Total a Pagar", width: "9%" },
        { title: "Total Pagado", width: "9%" },
        { title: "Saldo Pendiente", width: "9%" },
        { title: "Monto Factoraje", width: "10%" },
        { title: `Cantidad a Pagar ${this.state.monedaDePago}`, width: "15%" },
      ];
    }
    return [
      { title: "Código", width: "10%" },
      { title: "Proyecto", width: "15%" },
      { title: "Fecha Vencimiento", width: "10%" },
      { title: "Moneda", width: "10%" },
      { title: "T. C.", width: "10%" },
      { title: "Total a Pagar", width: "10%" },
      { title: "Total Pagado", width: "10%" },
      { title: "Saldo Pendiente", width: "10%" },
      { title: `Cantidad a Pagar ${this.state.monedaDePago}`, width: "15%" },
    ];
  }

  renderTcGlobalHeader() {
    return (
      <FormItem noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const monedaId = getFieldValue('monedaId')
          if (!monedaId || monedaId === '60c7e4396465ad440c41c15a') return null
          return (
            <Row gutter={[8, 8]} style={{ marginBottom: 8 }}>
              <Col xs={0} sm={0} md={14} lg={16} xl={17} />
              <Col xs={24} sm={24} md={10} lg={8} xl={7}>
                <div
                  style={{
                    padding: '6px 8px',
                    border: '2px dashed #00BFD6',
                    marginRight: 20,
                    borderRadius: 6,
                  }}
                >
                  <Row gutter={4} align="middle" wrap={false}>
                    <Col flex="auto">
                      <FormItem noStyle name="tipoDeCambioGlobal" type="number">
                        <InputNumberItem
                          size='small'
                          dinero
                          placeholder="T. C. Ventas"
                          style={{ width: '100%' }}
                          onPressEnter={this.aplicarTipoCambioVentas}
                        />
                      </FormItem>
                    </Col>
                    <Col>
                      <ButtonItem
                        size='small'
                        type='primary'
                        onClick={this.aplicarTipoCambioVentas}
                      >
                        Aplicar
                      </ButtonItem>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )
        }}
      </FormItem>
    );
  }

  renderVentaRow({ key, name, restField, arrayKey }) {
    return (
      <tr key={key}>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, fontWeight: 600, color: '#1a3a4a' }}>
            {this.state.ventasCliente[arrayKey].numero}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {this.state.ventasCliente[arrayKey].proyectoNombre}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {moment(this.state.ventasCliente[arrayKey].fechaPago).locale('es').format('L')}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {this.state.ventasCliente[arrayKey].monedaAbreviacion}
          </p>
        </td>
        <td className="td-border" style={{ textAlign: 'center' }}>
          <FormItem
            {...restField}
            name={[name, "tipoDeCambioVenta"]}
            fieldKey={[arrayKey, "tipoDeCambioVenta"]}
            noStyle
            numberCero
            initialValue={1}
            type='number'
          >
            <InputNumberItem
              sinBorde
              disabled={this.state.ventasCliente[arrayKey].monedaId === '60c7e4396465ad440c41c15a'}
              style={{ width: '100%', textAlign: 'center' }}
              placeholder={'Venta: ' + this.state.ventasCliente[arrayKey].tipoDeCambio}
              dinero
              size='small'
            />
          </FormItem>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(this.state.ventasCliente[arrayKey].totalPagar)}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(this.state.ventasCliente[arrayKey].totalPagado)}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#ee3b3e', fontWeight: 600 }}>
            {dineroDisabledMask(this.state.ventasCliente[arrayKey].saldoPendiente)}
          </p>
        </td>
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const pagarConFactoraje = getFieldValue('pagarConFactoraje')
            if (pagarConFactoraje) {
              let ventas = this.formRef.current.getFieldValue('ventas')
              let tipoDeCambioPago = getFieldValue('tipoDeCambioPago')
              let tipoDeCambioVenta = ventas[arrayKey].tipoDeCambioVenta
              const equivalencia = tipoDeCambioPago / tipoDeCambioVenta
              let totalPagar = this.state.ventasCliente[arrayKey].totalPagar || 0;
              let totalPagado =
                this.state.ventasCliente[arrayKey].totalPagado || 0;

              const saldoPendiente = round2Decimals(
                (totalPagar - totalPagado) / equivalencia
              );

              return (
                <td className="td-border-right">
                  <FormItem
                    number
                    margin
                    name={[name, "montoFactoraje"]}
                    fieldKey={[arrayKey, "montoFactoraje"]}
                    noStyle
                    type="number"
                    max={saldoPendiente}
                  >
                    <InputNumberItem dinero placeholder="Monto Factoraje" />
                  </FormItem>
                </td>
              )
            }
            return null
          }}
        </FormItem>
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {

              const ventas = getFieldValue('ventas')

              const tipoDeCambioVenta = ventas[arrayKey].tipoDeCambioVenta
              const tipoDeCambioPago = getFieldValue('tipoDeCambioPago')

              const equivalencia = tipoDeCambioPago / tipoDeCambioVenta

              const saldoPendiente = round2Decimals(
                (this.state.ventasCliente[arrayKey].saldoPendiente) / equivalencia
              );

              const cantidadPagar = ventas?.[arrayKey]?.cantidadPagar || 0;
              const esTotal = cantidadPagar > 0 && cantidadPagar === saldoPendiente;

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}>
                  <ButtonItem
                    size="small"
                    olivo
                    style={{ padding: '12px 12px' }}
                    type={esTotal ? 'primary' : 'default'}
                    title="Asignar total"
                    onClick={() => {
                      const ventasVal = this.formRef.current.getFieldValue("ventas");
                      if (!esTotal) {
                        ventasVal[arrayKey].cantidadPagar = saldoPendiente;
                      } else {
                        ventasVal[arrayKey].cantidadPagar = null;
                      }
                      this.formRef.current.setFieldsValue({ ventas: ventasVal });
                    }}
                  >
                    Total
                  </ButtonItem>
                  <div style={{ flex: 1 }} className={esTotal ? 'cantidad-pagar-total' : ''}>
                    <FormItem
                      {...restField}
                      name={[name, "cantidadPagar"]}
                      fieldKey={[arrayKey, "cantidadPagar"]}
                      noStyle
                      numberCero
                      type='number'
                      max={saldoPendiente}
                    >
                      <InputNumberItem style={{ width: '100%' }} placeholder={'Max: ' + saldoPendiente} dinero size='small' />
                    </FormItem>
                  </div>
                </div>
              )
            }}
          </FormItem>
        </td>
      </tr>
    );
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <style>{`
          .cantidad-pagar-total .ant-input-number-input {
            font-weight: 700 !important;
          }
        `}</style>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Ventas por Cobrar"
          style={{
            border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10,
          }}
        />
        <div
          style={{
            backgroundColor: "#e6f7fa", padding: "15px 20px", marginBottom: 10, border: "1px solid #b3ecf3",   borderLeft: "4px solid #00BFD6", borderRadius: 5, display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <FileTextOutlined style={{ color: "#00BFD6", fontSize: 18 }} />
          <span style={{ color: "#262626", fontWeight: "bold", fontSize: 16 }}>
            {this.props.location.state.nombre || "Cargando..."}
          </span>
        </div>
        {this.state.notasDeCreditoPendiente.length > 0 &&
          <Alert onClick={() => this.formRef.current.setFieldsValue({ pagarConNotas: true, pagarConAnticipo: false, anticipoId: undefined })} style={{ marginBottom: 10 }} description='Cambie a notas de credito para cobrar con una de ellas' showIcon message="Este cliente contiene notas de credito pendientes" type="warning" />
        }
        {this.state.anticiposPendientes.length > 0 &&
          <Alert style={{ marginBottom: 10 }} description='Los anticipos se aplican al crear la venta, en la pestaña Anticipos de Agregar Venta' showIcon message="Este cliente contiene anticipos pendientes" type="warning" />
        }
        {this.state.abonosPendientesClientes.length > 0 &&
          <Alert onClick={() => this.formRef.current.setFieldsValue({ pagarConAbono: true, pagarConNotas: false, pagarConAnticipo: false, abonoId: undefined })} style={{ marginBottom: 10 }} description='Cambie a abonos para cobrar con uno de ellos' showIcon message="Este cliente contiene abonos pendientes" type="warning" />
        }
        {this.state.clientesMismoRfc.length > 0 &&
          <Alert
            style={{ marginBottom: 10 }}
            showIcon
            type="info"
            message={(this.state.clientesMismoRfc.length === 1 ? "Hay 1 cliente más" : "Hay " + this.state.clientesMismoRfc.length + " clientes más") + " con el mismo RFC y razón social con ventas pendientes"}
            description={this.state.clientesMismoRfc.map((c) => c.nombre + " (" + c.ventasPendientes + (c.ventasPendientes === 1 ? " venta)" : " ventas)")).join(", ")}
            action={
              <Space>
                <span>Incluir sus ventas en este cobro</span>
                <Switch
                  checked={this.state.incluirMismoRfc}
                  loading={this.state.cargandoMismoRfc}
                  disabled={this.state.loading}
                  onChange={(checked) => this.alternarIncluirMismoRfc(checked)}
                />
              </Space>
            }
          />
        }
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="ventasPendientesCliente"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
            <Row gutter={[16, 16]} style={{ marginBottom: 15 }}>
              <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                <DynamicCardForm
                  title={<Space size={8}><span>MONEDA</span></Space>}
                  span={24} xs={24} sm={24} md={24} lg={24} xl={24}
                >
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const pagarConNotas = getFieldValue('pagarConNotas')
                        const pagarConAnticipo = getFieldValue('pagarConAnticipo')
                        const pagarConAbono = getFieldValue('pagarConAbono')
                        return (
                          <FormItem
                            required
                            margin
                            name="monedaId"
                            label="Moneda Pago"
                            labelCol={{ span: 9 }}
                            wrapperCol={{ span: 12 }}
                            initialValue={'60c7e4396465ad440c41c15a'}
                          >
                            <SelectItem
                              placeholder="Moneda"
                              disabled={pagarConNotas || pagarConAnticipo || pagarConAbono}
                              onChange={(value) => {
                                if (!value) return

                                this.onChangeMoneda(value)

                                const moneda = this.state?.todasMonedas?.find(
                                  (m) => m._id.toString() === value.toString()
                                )

                                if (moneda) {
                                  this.setState({ monedaDePago: moneda.abreviacion })
                                }
                              }}
                            >
                              {this.state.objetoMonedas}
                            </SelectItem>
                          </FormItem>
                        )
                      }}
                    </FormItem>
                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.pagarConNotas !== curr.pagarConNotas || prev.pagarConAnticipo !== curr.pagarConAnticipo || prev.pagarConAbono !== curr.pagarConAbono}>
                      {({ getFieldValue }) => {

                        const monedaId = getFieldValue('monedaId')

                        const pagarConNotas = getFieldValue('pagarConNotas')

                        const pagarConAnticipo = getFieldValue('pagarConAnticipo')

                        const pagarConAbono = getFieldValue('pagarConAbono')

                        const moneda = this.state.todasMonedas ? this.state.todasMonedas.find((valueTodasMonedas) => valueTodasMonedas._id.toString() === monedaId.toString()) : null

                        return (
                          <FormItem
                            required
                            number
                            margin
                            hidden={monedaId === '60c7e4396465ad440c41c15a'}
                            label={`T. C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                            name="tipoDeCambioPago"
                            type="number"
                            initialValue={1}
                            labelCol={{ span: 9 }}
                            wrapperCol={{ span: 12 }}
                          >
                            <InputNumberItem
                              disabled={monedaId === '60c7e4396465ad440c41c15a' || pagarConNotas || pagarConAnticipo || pagarConAbono}
                              dinero
                              placeholder={`T. C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                            />
                          </FormItem>
                        )
                      }}
                    </FormItem>
                </DynamicCardForm>
                </Col>
               <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                  <DynamicCardForm
                    title={<Space size={8}><span>DATOS DE PAGO</span></Space>}
                    span={24} xs={24} sm={24} md={24} lg={24} xl={24}
                  >
                    <Row gutter={16}>
                      <Col span={12}>
                      <FormItem
                        label="Fecha de Pago"
                        name="fechaPago"
                        required
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <DatePickerItem
                          placeholder="Fecha de Pago"
                          allowClear={false}
                          showTime
                          dateFormat='DD/MM/YYYY HH:mm:ss'
                          onChange={(date) => {
                            const monedaId = this.formRef.current.getFieldValue('monedaId')
                            if (monedaId && monedaId !== '60c7e4396465ad440c41c15a') {
                              this.onChangeMoneda(monedaId, date, true)
                            }
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Proyecto"
                        name="proyectoId"
                        required
                        margin
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <SelectProyectosItem
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          width="100%"
                          placeholder="Proyecto"
                        />
                      </FormItem>
                      </Col>
                      {this.state.factorajeFinancieroCXC &&
                        <Col span={12}>
                        <FormItem
                          name="pagarConFactoraje"
                          label="Factoraje"
                          tooltip={{ title: "Cobrar la venta con factoraje financiero" }}
                          margin
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 15 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            onChange={(checked) => {
                              if (checked) {
                                this.formRef.current.setFieldsValue({
                                  pagarConNotas: false,
                                  notaId: null,
                                  pagarConAnticipo: false,
                                  anticipoId: null,
                                  pagarConAbono: false,
                                  abonoId: null,
                                  pagarConIncobrable: false,
                                  pagarConAjusteCentavos: false,
                                })
                              }
                              this.setState({ pagarConFactoraje: checked })
                            }}
                            placeholder="Cobrar Con Factoraje"
                          />
                        </FormItem>
                        </Col>
                      }
                      {this.state.notasDeCreditoPendiente.length > 0 &&
                        <Col span={12}>
                        <FormItem
                          name="pagarConNotas"
                          label="Cobrar C/Notas"
                          tooltip={{ title: "Cobrar la factura con notas de credito" }}
                          margin
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 15 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            onChange={(checked) => {
                              if (checked) {
                                this.formRef.current.setFieldsValue({ pagarConAnticipo: false, anticipoId: null, pagarConAbono: false, abonoId: null })
                              }
                              this.setState({ pagarConNotas: checked })
                            }}
                            placeholder="Cobrar Con Notas"
                          />
                        </FormItem>
                        </Col>
                      }
                      {this.state.anticiposPendientes.length > 0 &&
                        <Col span={12}>
                        <FormItem
                          name="pagarConAnticipo"
                          label="Cobrar C/Anticipo"
                          tooltip={{ title: "Cobrar la venta con un anticipo" }}
                          margin
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 15 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            disabled
                            onChange={(checked) => {
                              if (checked) {
                                this.formRef.current.setFieldsValue({ pagarConNotas: false, notaId: null, pagarConAbono: false, abonoId: null })
                              }
                            }}
                            placeholder="Cobrar Con Anticipo"
                          />
                        </FormItem>
                        </Col>
                      }
                      {this.state.abonosPendientesClientes?.length > 0 &&
                        <Col span={12}>
                        <FormItem
                          name="pagarConAbono"
                          label="Cobrar C/Abono"
                          tooltip={{ title: "Cobrar la venta con un abono" }}
                          margin
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 15 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            onChange={(checked) => {
                              if (checked) {
                                this.formRef.current.setFieldsValue({ pagarConNotas: false, notaId: null, pagarConAnticipo: false, anticipoId: null })
                              }
                            }}
                            placeholder="Cobrar Con Abono"
                          />
                        </FormItem>
                        </Col>
                      }
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const pagarConFactoraje = getFieldValue('pagarConFactoraje')

                          if (pagarConFactoraje) {
                            return (
                              <Col span={12}>
                              <FormItem
                                label="Proveedor Factoraje"
                                name="proveedorFactorajeId"
                                required
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 15 }}
                                margin
                              >
                                <SelectProveedoresItem
                                  empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                  headersToken={this.props.headersToken}
                                  factorajeFinancieroCXC
                                  sinBorde
                                  autoFocus
                                  dropdownMatchSelectWidth={600}
                                  width="100%"
                                  placeholder="Proveedor Factoraje"
                                />
                              </FormItem>
                              </Col>
                            )
                          }
                        }}
                      </FormItem>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const pagarConNotas = getFieldValue('pagarConNotas')
                          const pagarConAnticipo = getFieldValue('pagarConAnticipo')
                          const pagarConAbono = getFieldValue('pagarConAbono')

                          if (pagarConNotas) {
                            return (
                              <Col span={12}>
                              <FormItem
                                label="Nota"
                                name="notaId"
                                margin
                                required
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 17 }}
                              >
                                <SelectItem placeholder="Nota" dropdownMatchSelectWidth={false} onChange={this.onChangeNotaDeCredito.bind(this)} >
                                  {this.state.objetoNotasPendiente}
                                </SelectItem>
                              </FormItem>
                              </Col>
                            )
                          } else if (pagarConAnticipo) {
                            return (
                              <Col span={12}>
                              <FormItem
                                label="Anticipo"
                                name="anticipoId"
                                margin
                                required
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 15 }}
                              >
                                <SelectItem placeholder="Anticipo" onChange={this.onChangeAnticipo.bind(this)} >
                                  {this.state.objetoAnticiposPendientes}
                                </SelectItem>
                              </FormItem>
                              </Col>
                            )
                          } else if (pagarConAbono) {
                            return (
                              <Col span={12}>
                              <FormItem
                                label="Abono"
                                name="abonoId"
                                margin
                                required
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 15 }}
                              >
                                <SelectItem placeholder="Abono" onChange={this.onChangeAbono.bind(this)} >
                                  {this.state.objetoAbonosPendientes}
                                </SelectItem>
                              </FormItem>
                              </Col>
                            )
                          } else {
                            return (
                              <>
                                <Col span={12}>
                                <FormItem
                                  label="Banco"
                                  name="bancoId"
                                  margin
                                  required
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 15 }}
                                >
                                  <SelectItem
                                    placeholder="Banco"
                                    onChange={(value) => {
                                      if (value) {
                                        const banco = this.state.todasBancos.find((banco) => banco?._id?.toString() === value?.toString())
                                        if (banco) {
                                          this.formRef.current.setFieldsValue({
                                            ctaBeneficiario: banco.ctaBeneficiario,
                                            rfcEmisorCtaBen: banco.rfcEmisorCtaBen,
                                          })
                                        }
                                      }
                                    }}
                                  >
                                    {this.state.objetoBancos}
                                  </SelectItem>
                                </FormItem>
                                </Col>
                                <Col span={12}>
                                <FormItem
                                  name="formaDePagoId"
                                  label="F Pago"
                                  margin
                                  required
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 15 }}
                                >
                                  <SelectItem placeholder="Forma de Pago">
                                    {this.state.objetoFormasDePago}
                                  </SelectItem>
                                </FormItem>
                                </Col>
                              </>
                            )
                          }
                        }}
                      </FormItem>
                      <Col span={12}>
                      <FormItem
                        name="referencia"
                        label="Referencia"
                        margin
                        pattern
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 15 }}
                      >
                        <InputItem placeholder="Referencia" />
                      </FormItem>
                      </Col>
                    </Row>
                  </DynamicCardForm>


               </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginBottom: 15 }}>
                <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                <DynamicCardForm
                  title={<Space size={8}><span>CALCULADORA</span></Space>}
                  span={24} xs={24} sm={24} md={24} lg={24} xl={24}
                >
                    <FormItem
                      label="Depósito Recibido"
                      name="deposito"
                      margin
                      labelCol={{ span: 9 }}
                      wrapperCol={{ span: 12 }}
                    >
                      <InputNumberItem
                        dinero
                        placeholder="Monto depositado"
                        onChange={() => {
                          this.forceUpdate();
                        }}
                      />
                    </FormItem>
                    <Space size={8} style={{ position: 'sticky', top: 0, zIndex: 1, marginTop: 20, fontWeight: 600, display: 'flex', width: '100%', padding: '8px 0', background: 'white', borderBottom: '2px solid #00BFD656' }}>
                      <DollarOutlined style={{ color: '#00BFD6', padding: '4px 4px 4px 4px', backgroundColor: 'rgba(0, 191, 214, 0.15)',borderRadius: '50%' }} />
                      <span>DIFERENCIA</span>
                    </Space>
                    <FormItem noStyle shouldUpdate>
                      {({ getFieldValue }) => {
                        const deposito = getFieldValue("deposito") || 0;
                        const ventas = getFieldValue("ventas") || [];
                        if (!deposito) return null;
                        const totalPagos = ventas.reduce(
                          (acc, v) => acc + (v.cantidadPagar || 0),
                          0
                        );
                        const restante = deposito - totalPagos;

                        return (
                          <div className="card-punteada" style={{ padding: '6px 8px', marginTop: 8, marginRight: 10 }}>
                            <p
                              style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: restante < 0 ? "red" : "green",
                                margin: 0,
                              }}
                            >
                              {restante >= 0
                                ? `Restante: ${dineroDisabledMask(restante)}`
                                : `Faltan: ${dineroDisabledMask(Math.abs(restante))}`}
                            </p>
                          </div>
                        );
                      }}
                    </FormItem>
                </DynamicCardForm>
                </Col>

               <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                <DynamicCardForm
                  title={<Space size={8}><span>DATOS COMPLEMENTO DE PAGO</span></Space>}
                  span={24} xs={24} sm={24} md={24} lg={24} xl={24}
                >
                    <Row gutter={16}>
                      <Col span={12}>
                       <FormItem
                          label="Cuentas Cliente"
                          margin
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 12 }}
                          tooltip="Selecciona una cuenta registrada para auto-rellenar los campos de abajo."
                        >
                          <Select
                            placeholder="Buscar en catálogo..."
                            showSearch
                            optionFilterProp="children"
                            onChange={this.onSelectCuentaGuardada}
                            allowClear
                          >
                            {this.state.objetoCuentasCliente}
                          </Select>
                        </FormItem>
                        <FormItem
                          label="Num Operacion"
                          name="numOperacion"
                          margin
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 12 }}
                          tooltip={{ title: "Se puede registrar el número de cheque, número de autorización, número de referencia, clave de rastreo en caso de ser SPEI, línea de captura o algún número de referencia o identificación análogo que permita identificar la operación correspondiente al pago efectuado." }}
                        >
                          <InputItem placeholder="Numero de Operacion" />
                        </FormItem>
                        <FormItem
                          label="Cta Ordenante"
                          name="ctaOrdenante"
                          number
                          max={50}
                          min={10}
                          margin
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 12 }}
                          tooltip={{ title: "Se puede registrar el número de la cuenta con la que se realizó el pago" }}
                        >
                          <InputItem placeholder="Cuenta Ordenante" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          label="Rfc Ordenante"
                          name="rfcEmisorCtaOrd"
                          rfc
                          margin
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 12 }}
                          tooltip={{ title: "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc" }}
                        >
                          <InputItem placeholder="Rfc Emisor Cuenta Ordenante" />
                        </FormItem>
                        {/* Regla CRP20223 del SAT: cuando el Rfc Ordenante es el RFC generico de
                            banco extranjero, el nombre del banco deja de ser opcional. Sin esto el
                            rechazo llega hasta el PAC, con el cobro ya armado y sin guardar. */}
                        <FormItem shouldUpdate={(prev, cur) => prev.rfcEmisorCtaOrd !== cur.rfcEmisorCtaOrd} noStyle>
                          {({ getFieldValue }) => (
                            <FormItem
                              name="nomBancoOrdExt"
                              label="Banco Ordenante"
                              margin
                              pattern
                              required={String(getFieldValue("rfcEmisorCtaOrd") || "").trim().toUpperCase() === "XEXX010101000"}
                              labelCol={{ span: 9 }}
                              wrapperCol={{ span: 12 }}
                              tooltip={{ title: "Se puede registrar el nombre del banco ordenante, es requerido en caso de ser extranjero" }}
                            >
                              <InputItem placeholder="Nombre Banco Ordenante" />
                            </FormItem>
                          )}
                        </FormItem>
                        <FormItem
                          label="Cta Beneficiario"
                          name="ctaBeneficiario"
                          number
                          max={50}
                          min={10}
                          margin
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 12 }}
                          tooltip={{ title: "Se puede registrar el número de cuenta en donde se recibió el pago." }}
                        >
                          <InputItem placeholder="Cuenta Beneficiario" />
                        </FormItem>
                        <FormItem
                          label="Rfc Beneficiaria"
                          name="rfcEmisorCtaBen"
                          rfc
                          margin
                          labelCol={{ span: 9 }}
                          wrapperCol={{ span: 12 }}
                          tooltip={{ title: "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc." }}
                        >
                          <InputItem placeholder="Rfc Emisor Cuenta Beneficiaria" />
                        </FormItem>
                      </Col>
                    </Row>
                </DynamicCardForm>
                </Col>
               
              </Row>

              <div style={{ marginTop: 24, marginBottom: 24 }}>
                <TabbedDynamicTable
                  isMobile={isMobile}
                  tabs={[
                    {
                      key: "ventas",
                      label: "Ventas Pendientes",
                      listName: "ventas",
                      hideTableWhenEmpty: false,
                      columns: this.getVentasColumns(),
                      renderHeader: () => this.renderTcGlobalHeader(),
                      renderRow: (rowProps) => this.renderVentaRow(rowProps),
                      agrupacion: this.agrupacionPorCliente(),
                    },
                  ]}
                />
              </div>
              <Row justify="end" style={{ marginTop: 16, marginBottom: 16 }}>
                <Col xs={24} sm={16} md={10} lg={10} xl={8}>
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      let ventas = getFieldValue('ventas')
                      if (!ventas) return null
                      let totalPagar = 0
                      ventas.map(value => {
                        let cantidadPagar = value.cantidadPagar ? value.cantidadPagar : 0
                        totalPagar += cantidadPagar
                        return null
                      })
                      return (
                        <DynamicCardForm
                          span={24}
                          noMargin
                          style={{
                            padding: 0,
                            borderLeft: '4px solid #FF6A0D',
                          }}
                          bodyStyle={{
                            padding: '12px 16px',
                          }}
                        >
                          <table className="table" style={{ width: '100%', margin: 0 }}>
                            <tbody>
                              <tr>
                                <th className="th-totales" style={{ fontSize: 17, fontWeight: 700 }}>
                                  Total a cobrar:
                                </th>
                                <td className="td-totales-right" style={{ fontSize: 18, fontWeight: 700 }}>
                                  {dineroDisabledMask(totalPagar)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </DynamicCardForm>
                      )
                    }}
                  </FormItem>
                </Col>
              </Row>
                   
              <div className="general-form-action-buttons-wrapper">
                <div className="general-form-action-buttons">
                  <Popconfirm
                    title={
                      this.state?.numeroFacturas > 0
                        ? (this.state?.numeroFacturas === 1 ? "Se generara un complemento de pago de 1 factura" : "Se generara un complemento de pago de " + this.state?.numeroFacturas + " facturas")
                        : "Cobrar"
                    }
                    onConfirm={() => this.formRef.current.formRef.current.submit()}
                    okText="Ok"
                    cancelText="Cancelar"
                  >
                    <ButtonItem
                      type='primary'
                      cyanB
                      hotkey="shift+c"
                      style={{ width: "5%" }}
                      onClick={() => {
                        let numeroFacturas = 0
                        //Cobrando con nota de credito no se timbra ningun complemento de pago
                        const pagarConNotas = this.formRef.current.formRef.current.getFieldValue('pagarConNotas')
                        const ventas = this.formRef.current.formRef.current.getFieldValue('ventas')
                        if (!pagarConNotas) {
                          ventas.map(valueVenta => {
                            if (valueVenta.factura && !valueVenta.cuentasXC && valueVenta.cantidadPagar > 0) {
                              numeroFacturas += 1
                            }
                            return null
                          })
                        }
                        this.setState({ numeroFacturas })
                      }}
                    >
                      Cobrar
                    </ButtonItem>
                  </Popconfirm>
                </div>
              </div>
            </Form>
          </Spin>
        </div>
        <MandarCorreoComplemento
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoComplemento={this.cerrarMandarCorreoComplemento.bind(this)}
        />
        <MandarCorreoPago
          visible={this.state.modalCorreoPago}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoPago={this.cerrarMandarCorreoPago.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerVentasCliente);
